import { fetchAuditLogs } from "app/services/AuditService";
import { useEffect, useState } from "react";

const AuditLogs = () => {
    const [logs, setLogs] = useState([]);
    const [filters, setFilters] = useState({});
    const [lastDoc, setLastDoc] = useState(null);

    const load = async (append = false) => {
        const res = await fetchAuditLogs({
            ...filters,
            lastDoc: append ? lastDoc : null,
        });

        setLogs((prev) => (append ? [...prev, ...res.rows] : res.rows));
        setLastDoc(res.lastDoc);
    };

    useEffect(() => {
        load();
    }, [filters]);

    return (
        <div>
            <h2>Audit Logs</h2>

            {/* Filter UI */}
            {/* action filter */}
            <select
                onChange={(e) =>
                    setFilters((f) => ({ ...f, action: e.target.value || null }))
                }
            >
                <option value="">All Actions</option>
                <option value="SEND EMAIL">Send Email</option>
                <option value="UPDATE USER">Update User</option>
            </select>

            {/* Table */}
            <table>
                <thead>
                    <tr>
                        <th>Action</th>
                        <th>Description</th>
                        <th>Entity</th>
                        <th>User</th>
                        <th>Created At</th>
                    </tr>
                </thead>

                <tbody>
                    {logs.map((log) => (
                        <tr key={log.id}>
                            <td>{log.action}</td>
                            <td>{log.description}</td>
                            <td>{log.entityType} - {log.entityId}</td>
                            <td>{log.userId}</td>
                            <td>{new Date(log.createdAt.seconds * 1000).toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Load More */}
            {lastDoc && (
                <button onClick={() => load(true)}>
                    Load More
                </button>
            )}
        </div>
    );
}

export default AuditLogs;